import { render, staticRenderFns } from "./MapSmallComponentStatic.vue?vue&type=template&id=2ec8b3c8&"
import script from "./MapSmallComponentStatic.vue?vue&type=script&lang=js&"
export * from "./MapSmallComponentStatic.vue?vue&type=script&lang=js&"
import style0 from "./MapSmallComponentStatic.vue?vue&type=style&index=0&id=2ec8b3c8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports